import { render, staticRenderFns } from "./GoogleRegistration.vue?vue&type=template&id=bb0ca090&"
import script from "./GoogleRegistration.vue?vue&type=script&lang=js&"
export * from "./GoogleRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports